(function (angular) {
    'use strict';

    angular.module('aprima-core-ui').component('apDocumentViewerWithDownload', {
        templateUrl: '/core-ui/component-views/apDocumentViewWithDownload.html',
        bindings: {
            disableFullscreen: '<?',
            disableInlinePdf: '<?',
            documentId: '<',
            documentHelper: '<?',
            downloadFileName: '<?',
            enableDownload: '<?',
            hasStaticUrl: '<?',

            documentDownload: '&?',
            documentGetStaticUrl: '&?',
            documentLoad: '&',
        },
        controller: [
            ApDocumentViewerWithDownload,
        ],
    });

    function ApDocumentViewerWithDownload(
    ) {
        var vm = this;

        vm.downloadingDocument = false;
        vm.loadingDocument = false;

        vm.canDownloadDocument = canDownloadDocument;
        vm.canOpenInSeparateTab = canOpenInSeparateTab;
        vm.onDocumentDownload = onDocumentDownload;
        vm.onDocumentLoad = onDocumentLoad;
        vm.onDocumentOpenInSeparateTab = onDocumentOpenInSeparateTab;

        function canDownloadDocument() {
            return vm.enableDownload;
        }

        function canOpenInSeparateTab() {
            return vm.hasStaticUrl;
        }

        function onDocumentDownload(documentId) {
            vm.downloadingDocument = true;
            return vm.documentDownload({
                documentId: documentId,
            }).finally(function () {
                vm.downloadingDocument = false;
            });
        }

        function onDocumentLoad(documentId, requestSettings) {
            vm.loadingDocument = true;
            return vm.documentLoad({
                documentId: documentId,
                requestSettings: requestSettings,
            }).finally(function () {
                vm.loadingDocument = false;
            });
        }

        function onDocumentOpenInSeparateTab(documentId) {
            if (vm.documentHelper) {
                vm.documentHelper.openDocumentInSeparateTab(vm.documentGetStaticUrl({
                    documentId: documentId,
                }));
            }
        }
    }
})(window.angular);
